// Description: Consumer-facing hook with ergonomic helpers


// Import the context hook from the provider file
import { useToastContext } from "../context/ToastProvider";


// Export the hook that app code should call
export function useToast() {

    // Access core actions and state from context
    const { addToast, removeToast, clearToasts, toasts } = useToastContext();

    // Provide sugar helpers for common variants - To style add ', autoCloseMs: 0' to ({})
    const toastSuccess = (opts) => addToast({ ...(opts || {}), type: "success" });
    const toastError = (opts) => addToast({ ...(opts || {}), type: "error"  });
    const toastWarning = (opts) => addToast({ ...(opts || {}), type: "warning" });
    const toastInfo = (opts) => addToast({ ...(opts || {}), type: "info" });

    // Return API surface to the caller
    return { toasts, addToast, removeToast, clearToasts, toastSuccess, toastError, toastWarning, toastInfo };

}